// extracted by mini-css-extract-plugin
module.exports = {"loadingCenter":"loading_loadingCenter__3hUSz"};